import React, { FC, useCallback, useMemo } from 'react';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { fundOwnershipUrl } from 'common/config/urls';
import { ValuationsParams } from 'pages/ValuationsAllocation/types';
import { getStringValue } from 'utilities';
import { RedirectToFundOwnershipButtonProps } from './types';

const ADD_OWNERSHIP_LABEL = 'Add Ownership';

const RedirectToFundOwnershipButton: FC<RedirectToFundOwnershipButtonProps> = params => {
  const { measurementDateSlug } = params;

  const navigate = useNavigate();

  const { firmSlugParam, companySlugParam } = useParams<ValuationsParams>();

  const financialPageUrl = useMemo(
    () => fundOwnershipUrl(getStringValue(firmSlugParam), getStringValue(companySlugParam)),
    [companySlugParam, firmSlugParam]
  );

  const redirectToFundOwnership = useCallback(() => {
    navigate(`${financialPageUrl}?date=${measurementDateSlug}`);
  }, [financialPageUrl, navigate, measurementDateSlug]);

  return (
    <Button color="primary" endIcon={<ArrowBackIcon />} onClick={redirectToFundOwnership} variant="outlined">
      {ADD_OWNERSHIP_LABEL}
    </Button>
  );
};

export default RedirectToFundOwnershipButton;
